export default {
  title: `<span class="ebc">EBC</span>
                    <span class="text pc">全球百万美金交易大赛Ⅱ</span>
                    <span class="text mobile">全球百万美金</span>`,
  title2: `<h1 class="title cn-font-family-title" style="margin-top:20rem">交易大赛Ⅱ</h1>`,
  巴萨传奇再启: "巴萨传奇再启",
  成就交易之王: "成就交易之王",
  距开赛: `距<br />开<br />赛`,
  天: "天",
  时: "时",
  分: "分",
  秒: "秒",
  一键跟单: "一键跟单",
  免费复制冠军收益: "免费复制冠军收益",
  公开透明: "公开透明",
  观摩冠军交易技巧: "观摩冠军交易技巧",
  推荐有礼: "推荐有礼",
  推荐有奖上不封顶: "推荐有奖上不封顶",
  立即参赛: "立即参赛",
  现金奖池: "现金奖池",
  巴萨梦之队: "巴萨梦之队",
  拉玛西亚组: "拉玛西亚组",
  冠军: "冠军",
  亚军: "亚军",
  季军: "季军",
  第四至五名: "第四至五名",
  第六至十名: "第六至十名",
  "$1,000,000交易账号或$200,000现金": "$1,000,000交易账号或$200,000现金",
  "1,000,000交易账号或200,000现金": "1,000,000交易账号或200,000现金",
  大赛推荐官: "大赛推荐官",
  推荐奖励: "推荐奖励 上不封顶",
  巴萨梦之队HTML: `<span>巴</span><span>萨</span><span>梦</span><span>之</span><span>队</span>`,
  拉玛西亚组HTML: ` <span>拉</span><span>玛</span><span>西</span><span>亚</span><span>组</span>`,
  "/人": "/人",
  活动时间: "活动时间：2025年3月1日0:00:00 - 2025年5月30日23:59:59 (GMT+3)",
  推荐流程: "推荐流程",
  推荐好友: "推荐好友",
  好友参赛: "好友交易",
  赢得奖金: "赢得奖金",
  实时赛况: "实时赛况",
  排名: "排名",
  昵称: "昵称",
  服务器: "服务器",
  账号: "账号",
  收益额: "收益额",
  收益率: "收益率",
  奖金: "奖金",
  跟单: "跟单",
  该页面仅展示收益表现排名前10的交易账号:
    "*该页面仅展示收益表现排名前10的交易账号，排名货币单位为美金USD，每小时同步更新。",
  赛事进程: "赛事进程",
  比赛开始: "比赛开始",
  推荐结束: "推荐结束",
  比赛结束: "比赛结束",
  颁奖典礼: "颁奖典礼",
  赛组规则: "赛组规则",
  类别: "类别",
  账号要求: "账号要求",
  "新交易账号，且账号余额大于$500": "新交易账号，且账号余额大于$500",
  "新交易账号，且$10,000≤账号余额≤$200,000":
    "新交易账号，且$10,000≤账号余额≤$200,000",
  排名规则: "排名规则",
  以收益率排名为评判标准: "以收益率排名为评判标准。",
  "收益率=期末净值/账号累积入金": "收益率=期末净值/账号累积入金",
  以净盈利额排名为评判标准: "以净盈利额排名为评判标准",
  持仓限制: "持仓限制",
  每个参赛账号最多持有100手仓位: "每个参赛账号最多持有100手仓位",
  无持仓限制: "无持仓限制",
  参赛条款: "参赛条款",
  参赛须知: "参赛须知",
  section6List: [
    {
      t: "1.活动时间",
      c: ["2025年3月1日00:00:00 - 2025年5月30日23:59:59（GMT+3）"],
    },
    {
      t: "2.账号要求",
      c: [
        "参赛账号需在交易社区发布为信号账号，但无需开放跟随，且不得跟随其他信号账号。",
        "参赛者可以使用多个账号参赛，但仅按表现最优的账号计入排名。",
        "仅限STD与PRO账号参赛，PAMM账户和伊斯兰账号不具备参赛资格。",
      ],
    },
    {
      t: "3.奖励规则",
      c: [
        "若冠军选择100万美金交易账号奖励，最大亏损限额为20万美金。",
        "其他奖项均按照排名进行奖励。",
      ],
    },
    {
      t: "4.禁止行为",
      c: [
        "严禁通过多账号进行恶意对冲以获取不正当成绩。",
        "因服务器硬件故障、报价错误等不可控因素导致的订单视为无效。",
        "EBC有权取消违规账户的参赛资格。",
      ],
    },
    {
      t: "5.最终解释权",
      c: ["EBC拥有本次活动最终解释权"],
    },
    {
      t: "6.活动时间",
      c: ["2025年3月1日00:00:00 - 2025年5月30日23:59:59（GMT+3）"],
    },
  ],
  参赛流程: "参赛流程",
  注册开户: "注册开户",
  注册并开设新交易账号: "注册并开设新交易账号",
  报名参赛: "报名参赛",
  在用户中心报名参赛: "在用户中心报名参赛",
  参赛成功: "参赛成功",
  参赛成功查看实时赛况: "参赛成功查看实时赛况",
  往届回顾:"往届回顾",
  第一届交易大赛颁奖典礼:"第一届交易大赛颁奖典礼",
  第一届交易大赛高光时刻:"第一届交易大赛高光时刻",
  第一届交易大赛巅峰对决:"第一届交易大赛巅峰对决",
  查看更多:"查看更多",
  常见问题: "常见问题",
  qaList: [
    {
      t: "1.账户与账号的区别",
      c: [
        "账户：指EBC用户中心账户（UID），每位用户经过实名认证后只能拥有一个账户。",
        "账号：MT交易账号，每个EBC账户可创建多个交易账号用于入金和交易。",
      ],
    },
    {
      t: "2.如何确认参赛成功？",
      c: ["参赛成功后，用户中心大赛活动页面会显示参赛账号及当前排名。"],
    },
    {
      t: "3.是否可以多账号参赛？",
      c: [
        "同一用户可分别在两个赛组使用多个账号参赛，但每个账号只能参加一个赛组。",
      ],
    },
    {
      t: "4.两个赛组同时获奖是否可同时领奖？",
      c: ["可同时领取两个赛组的奖励，前提是两个组别均合规完成比赛并获奖。"],
    },
    {
      t: "5.已有MT4账号可否参赛？",
      c: ["参赛账号需为2025年2月1日后创建，且无历史交易记录。"],
    },
    {
      t: "6.参赛拉玛西亚组后，再次入金超1万美金会修改参赛组别吗？",
      c: ["不会，参赛组别以参赛报名时为准，后续资金变动不影响组别。"],
    },
    {
      t: "7.如何查看比赛排名？",
      c: ["排名每小时更新，可在用户中心大赛活动页查看。"],
    },
    {
      t: "8.比赛期间能否出入金？",
      c: [
        "可自由出入金，但入金会影响收益率计算（收益率=期末净值/账号累积入金）。",
      ],
    },
    {
      t: "9.如何申领邀请奖励？",
      c: [
        "比赛结束后7个工作日内，更新“被邀请”用户完赛状态并发放奖金，客服将联系获奖者。",
      ],
    },
    {
      t: "10.比赛期间为何“被邀请”者不能转移代理？",
      c: [
        "为确保公平，“被邀请”者需通过推荐链接参与且不能指定代理，避免重复领取佣金和奖金。活动结束后可联系客服绑定代理。",
      ],
    },
  ],
};
